import radio from 'radio';

const notify = (notification) => {
  radio('notification:create').broadcast(notification);
};

export default notify;


